export default __webpack_public_path__ + "static/media/slide-3.28088dc7.png";